export default __webpack_public_path__ + "static/media/imageOne.525ef0ed.svg";